import React, { PureComponent } from 'react';
import {
  shape, array, string, func, bool, number,
} from 'prop-types';
import noop from 'lodash/noop';
import Responsive from '@active/react-utils/components/Responsive';
import ConfirmationMessage from './components/ConfirmationMessage';
import ActiveAdvantagePostSell from '../Offers/components/ActiveAdvantagePostSell';
import { handleKeyboardEvent } from '../../../shared/utils/commonUtils';
import PaymentDetails from './components/PaymentDetails';
import FullInfoPaymentResult from './components/FullInfoPaymentResult';

export default class PaymentResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShowOrderDetail: false,
    };
  }

  static propTypes = {
    orderPaymentResult: shape({
      orderPaymentResultList: array,
    }),
    confirmationMessage: shape({
      subTitle: string,
      isShowConfirmPagePrintButton: bool,
      isShowConfirmPageThanksSection: bool,
    }),
    trackingCallback: func,
    orderInfo: shape({
      totalAmount: number,
      currencyCode: string,
    }),
    locale: string,
    orderReviewModel: string,
    showFullInfoPaymentResult: bool,
  }

  static defaultProps = {
    orderPaymentResult: {
      orderPaymentResultList: [],
    },
    confirmationMessage: {
      subTitle: undefined,
      isShowConfirmPagePrintButton: true,
      isShowConfirmPageThanksSection: true,
    },
    trackingCallback: noop,
    orderInfo: {},
    showFullInfoPaymentResult: true,
  }

  handlePrint = () => {
    const { trackingCallback } = this.props;
    if (document.queryCommandSupported('print')) {
      document.execCommand('print', false, null);
    } else {
      window.print();
    }
    trackingCallback({ id: 'cui.print.clicked' });
  }

  toggleDetail = () => {
    this.setState(({ isShowOrderDetail }) => ({
      isShowOrderDetail: !isShowOrderDetail,
    }), () => {
      const { isShowOrderDetail } = this.state;
      const { trackingCallback } = this.props;
      trackingCallback({ id: `cui.${isShowOrderDetail ? 'seeDetail' : 'seeSummary'}.clicked` });
    });
  }

  renderSubTitle = (isShowConfirmPageThanksSection, subTitle) => {
    return <div data-testid="sub-title" className="payment-result__subTitle-text">
      { isShowConfirmPageThanksSection && subTitle }
    </div>;
  }

  render() {
    const {
      orderPaymentResult: {
        orderPaymentResultList, submitAaPostToken, initAaPostToken, membershipEmail,
        businessDate,
      },
      widgetNameSpace,
      confirmationMessage: {
        subTitle,
        confirmationMsg,
        confirmationMsgsForAgencies,
        confirmationBottomMsg,
        isShowConfirmPageThanksSection = true,
        isShowConfirmPagePrintButton = true,
      },
      trackingCallback,
      orderInfo: {
        totalAmount,
        currencyCode,
      },
      locale,
      orderDescription,
      orderReviewModel,
      showFullInfoPaymentResult,
    } = this.props;
    const { isShowOrderDetail } = this.state;

    if (orderPaymentResultList.length === 0) {
      return null;
    }

    const firstOrderPaymentResult = orderPaymentResultList[0].paymentResultList || [];

    return (
      <div className="payment-result">
        <Responsive not eqAbove="xl">
          <>
            {isShowConfirmPageThanksSection && subTitle
            && <div className="payment-result__subTitle">
              {this.renderSubTitle(isShowConfirmPageThanksSection, subTitle)}
            </div>}
          </>
        </Responsive>
        <Responsive eqAbove="xl">
          { ((isShowConfirmPageThanksSection && subTitle) || isShowConfirmPagePrintButton)
            && <div className="payment-result__subTitle">
              {this.renderSubTitle(isShowConfirmPageThanksSection, subTitle)}
              {isShowConfirmPagePrintButton
                && <span data-testid="ic-printer" className="ic-printer payment-result__subTitle-printer" role='button' aria-label='print' tabIndex={0} onClick={this.handlePrint}
                  onKeyDown={handleKeyboardEvent(this.handlePrint, [ 'Enter' ])}/>
              }
            </div>
          }
        </Responsive>
        <ActiveAdvantagePostSell
          locale={locale}
          trackingCallback={trackingCallback}
          membershipEmail={membershipEmail}
          firstOrderPaymentResult={firstOrderPaymentResult}
          widgetSubmitToken={submitAaPostToken}
          widgetInitToken={initAaPostToken}
          widgetNameSpace={widgetNameSpace}/>
        <div className="payment-result__content">
          {
            showFullInfoPaymentResult
              ? <FullInfoPaymentResult
                isShowOrderDetail={isShowOrderDetail}
                totalAmount={totalAmount}
                currencyCode={currencyCode}
                locale={locale}
                trackingCallback={trackingCallback}
                confirmationMsg={confirmationMsg}
                confirmationMsgsForAgencies={confirmationMsgsForAgencies}
                orderDescription={orderDescription}
                toggleDetail={this.toggleDetail}
                businessDate={businessDate}
                orderReviewModel={orderReviewModel}
                orderPaymentResultList={orderPaymentResultList}/>
              : <PaymentDetails confirmationMsg={confirmationMsg} orderPaymentResultList={orderPaymentResultList}/>
          }
          <ConfirmationMessage confirmationMsg={confirmationBottomMsg} className='cui-mg-t-60'/>
        </div>
      </div>
    );
  }
}
